import * as Storage from '@spica-devkit/storage';
import { Authentication } from './auth.service';

const authentication = new Authentication();

class SpicaStorage {
  constructor() {
    const token = authentication.getToken();
    const initConfig = {
      publicUrl: process.env.REACT_APP_API_URL!,
      identity: token!,
    };
    Storage.initialize(initConfig);
  }

  upload(data: any) {
    return Storage.insert(data);
  }

  delete(id: string) {
    return Storage.remove(id);
  }

  getId() {
    return Storage.getAll();
  }
}

const spicaStorageService = new SpicaStorage();
export default spicaStorageService;
